<template>
	<div class="bcgl">
		<div style="margin: 0rem 0 0 0rem; border: 1px #DDDDDD solid;">
			<el-card class="box-card">
				<div slot="header">
					<el-row style="margin-bottom: 20px">

						<el-col :span="24">
							<div style="line-height: 2.5rem; font-size: 1.5rem;">黑名单</div>
						</el-col>
					</el-row>
					<el-row style="text-align: left">
						<el-form :inline="true" :model="searchForm" @keyup.enter.native="getUserList()">
							<el-form-item >
								<el-select @change="changeIndex" clearable :disabled="deptdisable" filterable   v-model="searchForm.dept"  placeholder="请选择大队">
									<el-option
											v-for="item in depts"
											:key="item.bmid"
											:label="item.bmmc"
											:value="item.bmid"
											:disabled="deptdisable">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item >
								<el-input @change="changeIndex" v-model="searchForm.name" placeholder="姓名" clearable></el-input>
							</el-form-item>
							<el-form-item >
								<el-input @change="changeIndex" v-model="searchForm.sfzhm" placeholder="身份证号码" clearable></el-input>
							</el-form-item>
							<el-form-item >
								<el-input @change="changeIndex" v-model="searchForm.gw" placeholder="岗位" clearable></el-input>
							</el-form-item>
							<el-form-item>
								<el-button  @click="getUserList()">查询</el-button>
								<el-button  @click="addBlackList()" type="primary" v-if="isAuth('blacklist:add')">添加</el-button>
								<!--<el-button v-if="isAuth('blacklist:remove')"  type="danger" @click="deleteHandle()">批量移除
								</el-button>-->
							</el-form-item>

						</el-form>
					</el-row>
				</div>

				<el-table
						:data="dataList"
						border
						@selection-change="selectionChangeHandle"
						:header-cell-class-name="handleHeaderClass"
						@sort-change="handleTableSort"
						style="width: 100%;">
					<el-table-column
							type="selection"
							header-align="center"
							align="center"
							width="50">
					</el-table-column>
					<el-table-column
							prop="username"

							header-align="center"
							align="center"
							show-overflow-tooltip
							label="工号">
					</el-table-column>
					<el-table-column
							prop="xm"

							header-align="center"
							align="center"
							show-overflow-tooltip
							label="姓名">
						<template slot-scope="scope">
							<el-button v-if="scope.row.inBlackList === 1" type="text" @click="showUser(scope.row)">{{scope.row.xm}}</el-button>
							<el-popover
									v-else-if="scope.row.inBlackList === 2"
									placement="right"
									width="400"
									trigger="hover">
								<div>
									<span>姓名：{{scope.row.xm}}</span>
								</div>
								<div>
									<span>身份证号：{{scope.row.sfzhm}}</span>
								</div>
								<div>
									<span>性别：{{scope.row.xb===2?'女':'男'}}</span>
								</div>
								<div>
									<span>证件地址：{{scope.row.zjdz}}</span>
								</div>
								<div>
									<span>移入黑名单日期：{{scope.row.inBlackListDate?scope.row.inBlackListDate.substr(0,10):''}}</span>
								</div>
								<div>
									<span>移入黑名单原因：{{scope.row.inBlackListReason}}</span>
								</div>
								<el-button type="text" slot="reference">{{scope.row.xm}}</el-button>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column
							prop="sfzhm"
							width="200"
							header-align="center"
							align="center"
							show-overflow-tooltip
							label="身份证号">
					</el-table-column>
					<el-table-column
							show-overflow-tooltip
							header-align="center"
							align="center"
							sortable="custom"
							label="部门" prop="zzdyqc">
						<template slot-scope="scope" >
							<span>{{ getBm(scope.row) }}</span>
						</template>
					</el-table-column>

					<el-table-column
							header-align="center"
							align="center"
							width="180"
							prop="inBlackListDate"
							sortable="custom"
							label="移入黑名单日期">
						<template slot-scope="scope">
							{{scope.row.inBlackListDate?scope.row.inBlackListDate.substr(0,10):''}}
						</template>
					</el-table-column>

					<el-table-column
							prop="inBlackListReason"
							header-align="center"
							align="center"
							width="180"
							show-overflow-tooltip
							label="原因">
					</el-table-column>
					<el-table-column
							fixed="right"
							header-align="center"
							align="center"
							width="150"
							:render-header="renderHeader"
							label="操作">
						<template slot-scope="scope">
							<el-button type="text" v-if="isAuth('blacklist:remove')"  size="small" @click="deleteHandle(scope.row.id,scope.row.inBlackList)">
								{{scope.row.inBlackList === 2?'删除':'移除'}}
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
						@size-change="sizeChangeHandle"
						@current-change="currentChangeHandle"
						:current-page="pageIndex"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="pageSize"
						:total="totalPage"
						layout="total, sizes, prev, pager, next, jumper">
				</el-pagination>
			</el-card>
			<el-dialog
					style="text-align: left"
					title="导出"
					:visible.sync="exportVisible"
			>
				<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
				<el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
					<el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
				</el-checkbox-group>
				<form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/yhgl/exportExcel?access_token='+this.$store.getters.token"  target="_blank">
					<input type="hidden" v-for="(value,key,index) in searchForm" :name="key"  :value="value" />
					<input type="hidden" name="fileds" value="" ref="fileds"/>
				</form>
				<span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
			</el-dialog>
			<add-black v-if="exceptionVisible" ref="exception" @refreshDataList="getUserList"></add-black>
		</div>

	</div>
</template>
<script>
	import {
		Vue,
		Component
	} from 'vue-property-decorator'

	import fa from "element-ui/src/locale/lang/fa";
	// import HistoryInfo from "./history-info.vue"
	import AddBlack from "./black_list_add.vue"
	import SetException from  './setexception'
	const exportFields=[
		{value:"username",name:"工号"},
		{value:"xm",name:"姓名"},
		{value:"xb",name:"性别"},
		{value:"sfzhm",name:"身份证号码"},
		{value:"zjdz",name:"证件地址"},
		{value:"sjhm",name:"手机号码"},
		{value:"zzmm",name:"政治面貌"},
		{value:"sg",name:"身高"},
		{value:"jrgsrq",name:"进入公司日期"},
		{value:"jrbbrq",name:"进入本部日期"},
		{value:"drbzwrq",name:"担任本职位日期"},
		{value:"jjxz",name:"缴金性质"},
		{value:"jyxz",name:"就业性质"},
		{value:"ly",name:"来源"},
		{value:"pxqk",name:"培训情况"},
		{value:"twjr",name:"退伍军人"},
		{value:"mz",name:"民族"},
		{value:"whcd",name:"文化程度"},
		{value:"ygxz",name:"用工性质"},
		{value:"zzdyqc",name:"组织单元全称"},
		{value:"ddbz",name:"大队班组"},
		{value:"khh",name:"开户行"},
		{value:"yhzh",name:"银行账号"},
		{value:"ghhy",name:"工会会员"},
		{value:"jzdz",name:"居住地址"},
		{value:"inBlackListDate",name:"移入黑名单日期"},
		{value:"inBlackListReason",name:"移入黑名单原因"}
	]
	@Component({
		name: 'history',
		components:{
			SetException,
			AddBlack
		}
	})

	export default class role extends Vue {
		loading = false;
		searchForm={
			inBlackList: 1,
			dept:'',
			name:'',
			username:'',
			sfzhm:'',
			page:'',
			pagesize:''
		}
		dataList=[]
		dataListSelections=[]
		pageIndex= 1;
		pageSize=10;
		totalPage= 0;
		orders=[];
		bmxx=[]
		isIndeterminate= false
		exportVisible=false
		checkAll=false
		fields=exportFields
		filedValues=exportFields.map(item => item.value)
		fieldList=[]
		depts=[]
		deptdisable = false
		exceptionVisible = false
		created() {
			this.getDepts()
			this.getbmxx()
			this.getUserList();
			// this.getTypes()

		}
		getbmxx() {
			let that = this;
			this.$request.get("/bjba/yhgl/getbmxx").then((res) => {
				console.log("bmxx:", res);
				that.bmxx = res.data;
			});
		}
		getDepts() {
			let that = this;
			this.$request.get('/bjba/kqtj/getFirstMentForUser',{
				params: {
					userid:this.$store.getters.username
				}

			}).then(res => {
				that.depts = res.data
				if(this.depts && this.depts[0]) {
					var zzdyqc = this.$store.getters.user.zzdyqc;
					if (zzdyqc != this.CONST_ZN_BM) {
						var zw = this.$store.getters.user.zw;
						if (zw) {
							if (zw == '01' || zw == '02' || zw == '03') {
								this.searchForm.dept = that.depts[0].bmid
								this.deptdisable = true
							}
						}

					}
				}
			})
		}
		getBm(user) {
			var ubmid;
			var bmmc;
			ubmid = user.zzdyqc;
			for (var i = 0; i < this.bmxx.length; i++) {
				if (this.bmxx[i].bmid == ubmid) {
					bmmc = this.bmxx[i].bmmc;
				}
			}
			return bmmc;
		}
		showUser(user) {
			this.$router.push({
				path: "/bjba/grzx",
				query: { username: user.username },
			});
		}
		getParams () {
			// const {username, currentPage} = this;
			this.searchForm.orders = encodeURI(JSON.stringify(this.orders))
			this.searchForm.page = this.pageIndex;
			this.searchForm.pagesize = 10;
			this.searchForm.userid = this.$store.getters.username;

		}
		// 分页获取用户列表
		getUserList () {
			this.loading = true;
			this.getParams();
			this.$request
					.get("/bjba/yhgl/getUserList", {
						params: this.searchForm,
					})
					.then((res) => {
						const { data } = res;
						console.log("列表数据：", data);
						this.dataList = data.data;
						this.totalPage = data.total;
						//this.total = data.totalElements
						this.loading = false;
					})
					.catch((err) => {
						this.$message({
							message: "获取用户列表出现异常!",
							type: "error",
							center: true,
							showClose: true,
						});
						this.loading = false;
						console.log(err);
					});
		}
		addBlackList() {
			this.exceptionVisible = true
			this.$nextTick(()=>{
				this.$refs.exception.init()
			})
		}
		// 设置列的排序为我们自定义的排序
		handleHeaderClass({ column }) {
			if(!column.multiOrder) column.multiOrder =''
			column.order = column.multiOrder
		}
		handleOrderChange (orderColumn, orderState) {
			let result = this.orders.find(e => e.orderColumn === orderColumn)
			if (result) {
				if(orderState)
					result.orderState = orderState
				else {
					var j =this.orders.indexOf(result);
					if(j !== -1) {
						this.orders.splice(j,1);
					}
				}
			} else {
				this.orders.push({
					orderColumn: orderColumn,
					orderState: orderState
				})
			}
			this.getUserList()
		}
// 上面缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
// 列表排序
		handleTableSort({ column }) {
			console.log(column.orderfield)
			column.multiOrder = column.order
			this.handleOrderChange(column.property, column.multiOrder)
		}
		getParams() {
			this.searchForm.orders = encodeURI(JSON.stringify(this.orders))
			this.searchForm.page = this.pageIndex;
			this.searchForm.pagesize = this.pageSize;
		}
		renderHeader (h) {
			return (
					<div class="clearfix">
							<span>操作</span>
							<el-button style="padding:5px;float:right" size="mini"
			onClick={()=>this.showExportDialog()}>导出</el-button></div>
		)
		}
		handleCheckAllChange(val) {
			this.fieldList = val ? this.filedValues: [];
			this.isIndeterminate = false;
		}
		handleCheckedItemChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.filedValues.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
		}

		showExportDialog() {
			this.exportVisible = true
		}
		exportExcel() {
			var filedLast = this.fields.filter(filed=>{
				return this.fieldList.indexOf(filed.value) !==-1
			})
			if(filedLast && filedLast.length>0) {
				this.getParams();
				this.$refs.fileds.value = JSON.stringify(filedLast)
				this.$refs.exportForm.submit();
			} else {
				this.$message({
					message: '请选择字段',
					type: 'error',
					duration: 1500
				})
				return
			}
	}
		addOrUpdateHandle (id) {
			this.addOrUpdateVisible = true
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id)
			})
		}
		// 删除
		deleteHandle (id,type) {
			let ids = id ? [id] : this.dataListSelections.map(item => {
				return item.id
			})
			this.$confirm(`${type===1?'确定将用户移除黑名单?':'确定将用户删除黑名单?'}`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/bjba/yhgl/blackListRemove/`,
					method: 'post',
					params: {userid:id,type:type}
				}).then(({data}) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500
						})
						this.getUserList()
					} else if(data && data.code ==500) {
						this.$message({
							message: data.message,
							type: 'error',
							duration: 1500
						})
					}
				})
			}).catch(() => {
			})
		}
		changeIndex() {
			this.pageIndex = 1
		}

		// 每页数
		sizeChangeHandle (val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		}
		// 当前页
		currentChangeHandle (val) {
			this.pageIndex = val
			this.getDataList()
		}
		// 多选
		selectionChangeHandle (val) {
			this.dataListSelections = val
		}
		//info
		showInfo (id) {
			this.infoVisible = true
			this.$nextTick(() => {
				this.$refs.info.init(id)
			})
		}
	}
</script>
<style lang="scss" scoped>
	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}
	.clearfix:after {
		clear: both
	}
</style>
